const BASE_URL = "https://301-redirect.fr";
// const BASE_URL = "https://evans-organised-losses-representation.trycloudflare.com";
function is404Page() {
  const title = document.querySelector("title");
  if (!title) return false;

  return title.textContent.trim().toLowerCase().includes("404");
}


function brokenLinks() {
  if (is404Page()) {
    const currentPath = window.location.pathname;
    fetch(`${BASE_URL}/broken-links`, {
      method: "POST",
      allowedHeaders: "Content-Type, Authorization, X-Custom-Header",

      headers: {
        "Content-Type": "application/json",
      
      },
      body: JSON.stringify({ path: currentPath, shop: Shopify.shop }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data, "===data");
        if (data.status === 201 && data.redirect && data.isAutoRedirect) {
          window.location.href = data.redirect;
        }
      })
      .catch((error) => {
      });
  }
}
brokenLinks();
const createPatternRedirects = async () => {
  if (is404Page()) {
  const path = window.location.pathname;

  const response = await fetch(`${BASE_URL}/create-pattern-redirects`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    
    },
    body: JSON.stringify({ path, shop: Shopify.shop }),
  });
  const data = await response.json();
  if (data) {
    window.location.href = data.target;
  }
}
};
createPatternRedirects();
